import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react';
import { apiAddCreateGroupListener, apiAddDeleteGroupListener, apiAddUpdateGroupListener, apiListGroups, apiRemoveListener } from 'apis/SensorApi';
import { useAuth } from './AuthContext';

const Context = createContext({});

export default function SensorGroupsProvider({ children }) {
  const { currentUser } = useAuth();
  const groupsRef = useRef([]);
  const [sensorGroups, setSensorGroups] = useState(groupsRef.current);
  /***** Processing *****/
  useEffect(() => {
    const listeners = [];
    const onCreateGroup = (group) => {
      // update list
      groupsRef.current.push(group);
      groupsRef.current.sort((g1,g2)=>-g1.createdAt.localeCompare(g2.createdAt));
      groupsRef.current = Object.assign([], groupsRef.current);
      setSensorGroups(groupsRef.current);
    }
    const onUpdateGroup = (group) => {
      // update list
      const target = groupsRef.current.find(g=>g.id===group.id);
      groupsRef.current.splice(groupsRef.current.indexOf(target), 1, group);
      groupsRef.current.sort((g1,g2)=>-g1.createdAt.localeCompare(g2.createdAt))
      groupsRef.current = Object.assign([], groupsRef.current);
      setSensorGroups(groupsRef.current);
    }
    const onDeleteGroup = (group) => {
      // update list
      groupsRef.current = groupsRef.current.filter(g=>g.id!==group.id);
      setSensorGroups(groupsRef.current);
    }
    const addListeners = async () => {
      await listGroups();
      let listener = await apiAddCreateGroupListener(onCreateGroup);
      listeners.push(listener);
      listener = await apiAddUpdateGroupListener(onUpdateGroup);
      listeners.push(listener);
      listener = await apiAddDeleteGroupListener(onDeleteGroup);
      listeners.push(listener);
    }
    if (currentUser) {
      addListeners();
      
    }
    return () => {
      while (true) {
        if (listeners.length===0) break;
        apiRemoveListener(listeners.pop());
      }
    }
  }, [!!currentUser])

  const listGroups = async () => {
    try {
      const res = await apiListGroups();
      if (res.success) {
        groupsRef.current = res.data;
        setSensorGroups(groupsRef.current);
      }
    }
    catch (e) {
      // console.error("ERROR", e);
    }
  }
  /***** Main Render *****/
  return (
    <Context.Provider value={{ sensorGroups, setSensorGroups }}>
      {children}
    </Context.Provider>
  );
}

export const useSensorGroups = () => useContext(Context);
